export default __webpack_public_path__ + "static/banner_mobile-11e10de2cb3d08025fea3caffb637e9d.png";